const styleSheet = (theme: any) => ({
  wrapper: {
    height: '100vh',
    width: '100%',
    backgroundColor: '#fff',
    overflowX: 'hidden',
  },
  mainContent: {
    marginTop: '37px',
    width: '100%',
    backgroundColor: '#f8f9fb',
    height: 'calc(100vh - 147px)',
  },
  sideBarIsOpen: {
    transition: 'all 300ms',
  },
  sideBarIsOpenDisplay: {
    display: 'block',
  },
  sideBarIsClosed: {
    transition: 'all 300ms',
  },
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/SideBar/MainContent/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/components/SideBar/MainContent/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }